import { render, staticRenderFns } from "./purchaseOrderDetails.vue?vue&type=template&id=b69d4b74&scoped=true"
import script from "./purchaseOrderDetails.vue?vue&type=script&lang=js"
export * from "./purchaseOrderDetails.vue?vue&type=script&lang=js"
import style0 from "./purchaseOrderDetails.vue?vue&type=style&index=0&id=b69d4b74&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b69d4b74",
  null
  
)

export default component.exports